var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Token/USDT"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.9 17.4C17.8 17.4 17.2 17.5 15.9 17.5C14.8 17.5 14.1 17.5 13.9 17.4C10 17.2 7 16.5 7 15.7C7 14.9 9.9 14.2 13.9 14V16.7C14.2 16.7 14.9 16.8 16 16.8C17.3 16.8 17.9 16.7 18 16.7V14C21.9 14.2 24.8 14.9 24.8 15.7C24.8 16.5 21.9 17.2 17.9 17.4ZM17.9 13.8V11.4H23.4V7.7H8.6V11.4H14.1V13.8C9.6 14 6.3 14.9 6.3 16C6.3 17.1 9.7 18 14.1 18.2V26H17.9V18.2C22.3 18 25.7 17.1 25.7 16C25.7 14.9 22.3 14 17.9 13.8Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenUsdt);
export default __webpack_public_path__ + "static/media/token_usdt.7e6a5176eaa04af73444d0c745804d6e.svg";
export { ForwardRef as ReactComponent };